import axios from 'axios'
import cookie from 'vue-cookie'
import Router from '@/router'

const instance = axios.create({
  baseURL: process.env.API_URL
})

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      switch (error.response.headers['www-authorization']) {
        case 'app':
          Router.push('/401')
          break

        case 'logarme':
          this.a.redirectToLogarme()
          break
      }
    }
    return Promise.reject(error)
  }
)

instance.interceptors.request.use(
  config => {
    config.headers['Authorization'] = cookie.get('token')
    config.headers['X-Merchant'] = cookie.get('merchant')
    return config
  },
  error => Promise.reject(error)
)

export default instance



// WEBPACK FOOTER //
// ./src/api/request.js